import {AppElement, html} from '../AppElement.js';
import TotalPickupTitle from "../totalPickupExpandCard/TotalPickupTitle";
import FlashExpandCard from "../expand/FlashExpandCard";
import Button from '../button/Button';
import Constants from "../Constants";
import TotalPickupExpandCardInfo from "../totalPickupExpandCard/TotalPickupExpandCardInfo";
import PickupPerMonthGroup from "../pickupPerMonth/PickupPerMonthGroup";
import YesterdayGroup from "../yesterday/YesterdayGroup";
import MiniContext from "../miniContext/MiniContext";
import NumericVarianceBlock from "../numericVarianceBlock/NumericVarianceBlock";

export default class FlashGroupGroupExpandCard extends AppElement {
    static get properties() {
        return {
            hotelGroup: { type: Object },
            recordDate: { type: String },
            pickupSetting: { type: Number }
        };
    }

    constructor(props = {}) {
        super();
        this.hotelGroup = props.hotelGroup || {};
        this.recordDate = props.recordDate;
        this.pickupSetting = props.pickupSetting;
        this.myvar = '';
        this.card = this.createCard();
    }

    reflow() {
        this.hotelGroup = props.hotelGroup || this.hotelGroup;
        this.recordDate = props.recordDate || this.recordDate;
        this.pickupSetting = props.pickupSetting || this.pickupSetting;

        this.card = this.createCard();
        this.fill();
    }

    fill() {
        if (
            !this.hotelGroup
            || typeof this.hotelGroup !== 'object'
            || !('id' in this.hotelGroup)
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.recordDate)
            || !$.isNumeric(this.pickupSetting)
        ) {
            return;
        }

        // Group headline from BI hotel-group aggregate (HotelIdsSeries), not a frontend sum of
        // hotel tiles. seriesCoverage drives the missing-hotel badge.
        const biStatistics = window.infinito.vao.model.biHotelGroupsStatistics;
        const flag = this;

        biStatistics.fetchStatistics(
            this.hotelGroup.id,
            biStatistics.buildQuery({
                recordDate: this.recordDate,
                fields: [
                    biStatistics.fields.roomsOtbTotalPickup,
                    biStatistics.fields.adrTotalPickup,
                    biStatistics.fields.revenueTotalPickup,
                    biStatistics.fields.seriesCoverage
                ],
                pickupOffset: this.pickupSetting
            }),
            function onStatistics(data, procData) {
                const _procData = procData || {};
                const roomsStat = _procData.roomsOtbTotalPickup || {};
                const roomsVal = roomsStat.value;
                const adrVal = (_procData.adrTotalPickup || {}).value;
                const revenueVal = (_procData.revenueTotalPickup || {}).value;
                const coverage = _procData.seriesCoverage || {};
                const coverageObj = coverage.objectValue || null;
                let missingCount = null;
                if (
                    coverageObj
                    && $.isNumeric(coverageObj.aggregated)
                    && $.isNumeric(coverageObj.total)
                ) {
                    const missing = Number(coverageObj.total) - Number(coverageObj.aggregated);
                    if (missing > 0) {
                        missingCount = missing;
                    }
                }

                const hasAnyValue = $.isNumeric(roomsVal)
                    || $.isNumeric(adrVal)
                    || $.isNumeric(revenueVal);

                if (!(flag.card instanceof FlashExpandCard) || !(flag.card.contentEl instanceof TotalPickupTitle)) {
                    return;
                }

                if (!hasAnyValue) {
                    flag.card.contentEl.reflow({
                        noData: true,
                        isLoading: false,
                        counters: missingCount
                    });
                    return;
                }

                let otb;
                if ($.isNumeric(roomsVal)) {
                    otb = new NumericVarianceBlock({
                        numericValue: roomsVal,
                        formattedValue: String(roomsVal),
                        tooltip: Constants.STRINGS.ROOMS
                    });
                } else {
                    otb = Constants.MISSING_STR;
                }

                let adr;
                if ($.isNumeric(adrVal)) {
                    const formattedAdr = window.infinito.vao.controller.moneyHelper.formatMoneyBracketStyle(
                        adrVal,
                        Constants.ADR_DIGITS,
                        true,
                        flag.hotelGroup.locale
                    );
                    adr = new NumericVarianceBlock({
                        numericValue: adrVal,
                        formattedValue: formattedAdr,
                        tooltip: Constants.STRINGS.ADR
                    });
                } else {
                    adr = Constants.MISSING_STR;
                }

                let rev;
                if ($.isNumeric(revenueVal)) {
                    const formattedRev = window.infinito.vao.controller.moneyHelper.formatMoneyBracketStyle(
                        revenueVal,
                        Constants.REVENUE_DIGITS,
                        true,
                        flag.hotelGroup.locale
                    );
                    rev = new NumericVarianceBlock({
                        numericValue: revenueVal,
                        formattedValue: formattedRev,
                        tooltip: Constants.STRINGS.REV
                    });
                } else {
                    rev = Constants.MISSING_STR;
                }

                // No single data-age for a group aggregate; keep the slot for the
                // seriesCoverage missing-hotel badge (TotalPickupTitle shows counters
                // only when duration is empty).
                flag.card.contentEl.reflow({
                    otb,
                    adr,
                    rev,
                    counters: missingCount,
                    noData: false,
                    isLoading: false
                });
            }
        );
    }

    onCardHelp() {
        window.infinito.components.basicModal.render({
            title: 'Skeleton',
            bodyElem: $(new TotalPickupExpandCardInfo())
        });
    }

    createCard() {
        const content = new TotalPickupTitle({
            name: this.hotelGroup.groupName,
            isLoading: true
        });

        const pickupPerMonthGroup = new PickupPerMonthGroup({
            hotelGroup: this.hotelGroup,
            recordDate: this.recordDate,
            pickupSetting: this.pickupSetting
        });

        const yesterdayBtn = new Button({
            text: 'Yesterday',
            color: 'light',
            size: 'small',
            onClick: () => {
                const yesterdayGroup = new YesterdayGroup({
                    recordDate: this.recordDate,
                    hotelGroup: this.hotelGroup
                });
                const prettyRecordDate = window.infinito.vao.controller.dateHelper
                    .getShortDayDateMonFullYearString(this.recordDate);
                const prettyStayDate = window.infinito.vao.controller.dateHelper.getShortDayDateMonFullYearString(
                    yesterdayGroup.yesterday
                );
                const $title =  $('<div></div>').append(
                    '<h5>Yesterday</h5>'
                ).append(new MiniContext({
                    recordDate: prettyRecordDate,
                    stayDate: prettyStayDate,
                    isModalStyle: false
                }));
                window.infinito.components.basicModal.render({
                    title: $title,
                    isTitleHtml: true,
                    bodyElem: $(yesterdayGroup)
                });
            }
        });

        const expand = html`
            <div 
                class="vao__components--flashGroupGroupExpandCard-btns" 
                style="padding:.5rem 0;display:flex;justify-content:flex-end;"
            >
                <div>${yesterdayBtn}</div>     
            </div>
            ${pickupPerMonthGroup} 
        `;

        return new FlashExpandCard({
            contentEl: content,
            expandEl: expand,
            onHelp: 'tooltips',
            isExpanded: false,
            borderCol: '#9c27b0'
        });
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.fill();
    }

    render() {
        return html`
        <div class="vao__components--flashGroupGroupExpandCard">
            ${this.card}     
        </div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.FlashGroupGroupExpandCard = FlashGroupGroupExpandCard;
customElements.define('vao-flash-group-group-expand-card', FlashGroupGroupExpandCard);
